import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from './Select';
import { getSeatMaps, clearSeatMaps, getBaseSeatMaps } from '../../../../actions';
import {
  inputPropTypes,
  metaPropTypes,
  inputDefaultProps,
  metaDefaultProps,
} from '../../forms/input/InputPropTypes';
import SelectFilter from '../../filters/SelectFilter';

const SeatMapSelect = ({
  dispatchGetSeatMaps,
  dispatchClearSeatMaps,
  options,
  isLoading,
  isMulti,
  input,
  meta,
  useForFilter,
  onChangeFilter,
  query,
  dispatchGetBaseSeatMaps,
  showOnlyBase,
  serviceTypeId,
  ...rest
}) => {
  
  useEffect(() => {
    if (showOnlyBase) {
      dispatchGetBaseSeatMaps({ serviceTypeId });
    }
    return () => dispatchClearSeatMaps();
  }, []);

  const handleSeatMapChange = (inputValue) => {

    if (showOnlyBase) return;

    if (inputValue.trim().length && inputValue.trim().length >= 4) {
      dispatchGetSeatMaps({ query: [inputValue, ...query] });
    }
  };

  if (useForFilter) {
    return (
      <SelectFilter
        isMulti
        onChangeFilter={onChangeFilter}
        onInputChange={handleSeatMapChange}
        options={options}
      />
    );
  }

  return (
    <Select
      options={options}
      isLoading={isLoading}
      isMulti={isMulti}
      input={input}
      meta={meta}
      onInputChange={handleSeatMapChange}
      {...rest}
    />
  );
};

SeatMapSelect.propTypes = {
  dispatchGetSeatMaps: PropTypes.func.isRequired,
  dispatchClearSeatMaps: PropTypes.func.isRequired,
  dispatchGetBaseSeatMaps: PropTypes.func.isRequired,
  isMulti: PropTypes.bool,
  input: inputPropTypes,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      route: PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.number,
      }),
    }),
  ),
  meta: metaPropTypes,
  isLoading: PropTypes.bool,
  useForFilter: PropTypes.bool,
  onChangeFilter: PropTypes.func,
  query: PropTypes.instanceOf(Array),
  showOnlyBase: PropTypes.bool,
  serviceTypeId: PropTypes.number,
};

SeatMapSelect.defaultProps = {
  input: inputDefaultProps,
  meta: metaDefaultProps,
  isLoading: false,
  isMulti: false,
  options: [],
  useForFilter: false,
  onChangeFilter: () => {},
  query: [],
  showOnlyBase: false,
  serviceTypeId: null,
};

const mapStateToProps = ({ BusUnit }) => ({
  options: BusUnit.SeatMap.getIn(['all', 'content', 'content']).map(
    (option) => ({
      value: option.id,
      label: option.name,
      floors: option.floors,
      numberOfFloors: option.numberOfFloors,
    }),
  ),
  loading: BusUnit.SeatMap.getIn(['all', 'loading']),
});

const mapDispatchToprops = {
  dispatchGetSeatMaps: getSeatMaps,
  dispatchClearSeatMaps: clearSeatMaps,
  dispatchGetBaseSeatMaps: getBaseSeatMaps,
};

export default connect(mapStateToProps, mapDispatchToprops)(SeatMapSelect);
